import React from "react";
import * as Icon from "react-feather";

import WComponent from "../common/WComponent";
import ToolsModal from "../clients/Tools/kit/ToolsModal";
import PlaybookScriptService from "../../services/PlaybookScriptService";

import "./playbook-build-scripts.css";

const EDIT_BUSY_KEY = "editScript";

class PlaybookScriptEditModal extends WComponent {
	constructor(props) {
		super(props);
		const { script } = props;
		const hasManifest = Boolean(script.manifest);
		this.state = {
			plainDescription: script.plainDescription || "",
			code: script.code || "",
			manifestText: hasManifest ? JSON.stringify(script.manifest, null, 2) : "",
			manifestError: null,
			refusal: null,
		};
	}

	onSave = async () => {
		const { script, sessionId, runScriptAction, onClose } = this.props;
		const { plainDescription, code, manifestText } = this.state;
		let manifest = null;
		try {
			manifest = JSON.parse(manifestText);
		} catch (error) {
			const manifestError = `The manifest is not valid JSON: ${error.message}`;
			await this.update({ manifestError, refusal: null });
			return;
		}
		await this.update({ manifestError: null, refusal: null });
		const editTheScript = () => PlaybookScriptService.editBuildScript({ sessionId, pinId: script.pinId, code, manifest, plainDescription });
		const { refusal } = await runScriptAction({ busyKey: EDIT_BUSY_KEY, action: editTheScript, pinId: script.pinId });
		if (refusal) {
			await this.update({ refusal });
			return;
		}
		onClose();
	};

	render() {
		const { script, isOpen, busyKey, onClose } = this.props;
		const { plainDescription, code, manifestText, manifestError, refusal } = this.state;
		const isBusy = busyKey !== null && busyKey !== undefined;
		const isSaving = busyKey === EDIT_BUSY_KEY;
		const title = `Edit script "${script.scriptKey}"`;

		const footer = (
			<div className="tk-modal-actions">
				<button type="button" className="tk-button tk-button--secondary" onClick={onClose} disabled={isBusy}>
					Cancel
				</button>
				<button type="button" className="tk-button tk-button--primary" onClick={this.onSave} disabled={isBusy}>
					{isSaving ? "Saving…" : "Save as a new revision"}
				</button>
			</div>
		);

		return (
			<ToolsModal open={isOpen} onClose={onClose} title={title} width={760} footer={footer}>
				<p className="playbook-script-edit__intro">
					Saving makes a new revision that is not approved: it needs a passing test (or a comparison with its stored test), a review and approval again.
				</p>
				<div className="tk-form-field">
					<div className="tk-form-label">What it does, in plain words</div>
					<textarea
						className="tk-input playbook-script-edit__text"
						rows={3}
						value={plainDescription}
						onChange={event => this.update({ plainDescription: event.target.value })}
						disabled={isBusy}
					/>
				</div>
				<div className="tk-form-field">
					<div className="tk-form-label">Code</div>
					<textarea
						className="tk-input playbook-script-edit__text playbook-script-edit__text--code"
						rows={14}
						value={code}
						onChange={event => this.update({ code: event.target.value })}
						spellCheck={false}
						disabled={isBusy}
					/>
				</div>
				<div className="tk-form-field">
					<div className="tk-form-label">Manifest</div>
					<textarea
						className="tk-input playbook-script-edit__text playbook-script-edit__text--code"
						rows={10}
						value={manifestText}
						onChange={event => this.update({ manifestText: event.target.value, manifestError: null })}
						spellCheck={false}
						disabled={isBusy}
					/>
					{manifestError ? (
						<div className="tk-form-help playbook-script-edit__field-error">{manifestError}</div>
					) : (
						<div className="tk-form-help">What the script reads and returns, as JSON.</div>
					)}
				</div>
				{refusal && (
					<div className="tk-notice tk-notice--danger playbook-script-edit__refusal">
						<div className="tk-notice__title">
							<Icon.AlertTriangle size={14} />
							{refusal}
						</div>
					</div>
				)}
			</ToolsModal>
		);
	}
}

export default PlaybookScriptEditModal;
